(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPreviewAccordionGrid(root) {
      if (!root || root.dataset.previewAccordionGridInit) return;
      root.dataset.previewAccordionGridInit = 'true';

      var grid = root.querySelector('[data-preview-grid-items]');
      var colButtons = root.querySelectorAll('[data-preview-grid-cols]');

      colButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.getAttribute('data-preview-grid-cols'), 10);
          if (!grid || n < 2 || n > 5) return;
          grid.style.setProperty('--grid-cols', String(n));
          colButtons.forEach(function (b) {
            var pressed = b === btn;
            b.classList.toggle('is-active', pressed);
            b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
          });
        });
      });
    }

    document.querySelectorAll('[data-preview-accordion-grid]').forEach(initPreviewAccordionGrid);

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target && event.target.querySelector
        ? event.target.querySelector('[data-preview-accordion-grid]')
        : null;
      if (el) initPreviewAccordionGrid(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-navigation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-collection-nav-mobile]');

    roots.forEach((root) => {
      const track = root.querySelector('[data-collection-nav-track]');
      const items = Array.from(root.querySelectorAll('[data-collection-nav-item]'));
      const dots = Array.from(root.querySelectorAll('[data-collection-nav-dot]'));
      if (!track || !items.length || !dots.length) return;

      const MOBILE_MAX = 749;
      const EDGE_THRESHOLD = 10;
      let scrollRaf = 0;

      const isMobile = () => window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;

      const getActiveIndex = () => {
        const scrollLeft = track.scrollLeft;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        if (scrollLeft <= EDGE_THRESHOLD) return 0;
        if (maxScroll > 0 && scrollLeft >= maxScroll - EDGE_THRESHOLD) return items.length - 1;

        const centerX = scrollLeft + track.clientWidth / 2;
        let bestIdx = 0;
        let bestDist = Infinity;

        items.forEach((el, i) => {
          const elCenterX = el.offsetLeft + el.offsetWidth / 2;
          const d = Math.abs(elCenterX - centerX);
          if (d < bestDist) {
            bestDist = d;
            bestIdx = i;
          }
        });

        return bestIdx;
      };

      const setDots = (index) => {
        dots.forEach((dot, i) => {
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      };

      const onScroll = () => {
        if (!isMobile()) return;
        cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => setDots(getActiveIndex()));
      };

      track.addEventListener('scroll', onScroll, { passive: true });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = Number(dot.dataset.index);
          const item = items[idx];
          if (!item) return;

          const pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const target = Math.max(0, Math.min(item.offsetLeft - pad, maxScroll));

          track.scrollTo({ left: target, behavior: 'smooth' });
        });
      });

      window.addEventListener('resize', () => {
        if (isMobile()) setDots(getActiveIndex());
      });

      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateHeroVideoButton(button, video) {
      // Video should always be muted; this toggle is play/pause only.
      if (!video.muted) video.muted = true;

      if (video.paused) {
        button.classList.add('is-paused');
        button.setAttribute('aria-label', 'Play video');
      } else {
        button.classList.remove('is-paused');
        button.setAttribute('aria-label', 'Pause video');
      }
    }

    function initHeroVideoToggles() {
      document.querySelectorAll('.hero__video-wrapper').forEach(function (wrapper) {
        const video = wrapper.querySelector('video');
        const button = wrapper.querySelector('[data-hero-video-toggle]');
        if (!video || !button) return;
        // Enforce muted always (autoplay policies are happier too).
        video.muted = true;
        video.setAttribute('muted', '');

        updateHeroVideoButton(button, video);
        if (video.paused) {
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () {}).then(function () {
              updateHeroVideoButton(button, video);
            });
          }
        }
      });
    }

    document.addEventListener('click', function (e) {
      const button = e.target.closest('[data-hero-video-toggle]');
      if (!button) return;
      const wrapper = button.closest('.hero__video-wrapper');
      const video = wrapper ? wrapper.querySelector('video') : null;
      if (!video) return;
      e.preventDefault();
      e.stopPropagation();
      // Always mute; toggle play/pause only.
      video.muted = true;
      video.setAttribute('muted', '');

      if (video.paused) {
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {}).then(function () {
            updateHeroVideoButton(button, video);
          });
        } else {
          updateHeroVideoButton(button, video);
        }
      } else {
        video.pause();
        updateHeroVideoButton(button, video);
      }
    });
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroVideoToggles);
    } else {
      initHeroVideoToggles();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
